import React from 'react';

import AlignmentSummaryMapView from 'analyses/alignment/AlignmentSummaryMapView';
import PolymerAlignmentTabView from 'analyses/alignment/PolymerAlignmentTabView';
import BenchlingConfig from 'BenchlingConfig';
import * as vo from 'components/VisibilityOptions';
import {MIN_WIDTH_FOR_INDEX} from 'molbio/maps/linear/AntibodyNumbering';
import Type from 'molbio/maps/Type';
import ProteinAlignmentRowView from 'molbio/proteins/alignments/ProteinAlignmentRowView';
import ProteinAlignmentTabState from 'molbio/proteins/alignments/ProteinAlignmentTabState';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

import ProteinAlignmentRowsView from './ProteinAlignmentRowsView';
import ProteinAlignmentStats from './ProteinAlignmentStats';

export default class ProteinAlignmentTabView extends PolymerAlignmentTabView<ProteinAlignmentTabState> {
  addPolymersForSearch(): void {
    // TODO
  }

  removePolymersForSearch(): void {
    // TODO
  }

  getType(): Type {
    return this.model.getType();
  }

  setType(typeObj: Type): void {
    this.model.setType(typeObj);
  }

  getPolymerLength(): number {
    return this.model.getPolymerLength();
  }

  renderStatsView(): JSX.Element | null {
    if (this.shouldCollapseMiniMap(this.model)) {
      return null;
    }

    return (
      <ProteinAlignmentStats
        alignment={this.model.get('alignment')!}
        selectionStart={this.model.get('selection').start()}
        selectionEnd={this.model.get('selection').end()}
      />
    );
  }

  makeSummaryMapView(): AlignmentSummaryMapView {
    return new AlignmentSummaryMapView({
      model: null,
      // @ts-expect-error tabstate not included in ViewOptions
      tabstate: this.model,
      topY: ['summaryIdentityGraph', 'line'],
      middleY: ['line'],
      bottomY: [],
      padding: 172, // Keep in sync with @handle-width + 2
      isCollapsed: this.shouldCollapseMiniMap(this.model),
    });
  }

  makeRowsView(): ProteinAlignmentRowsView {
    return new ProteinAlignmentRowsView({model: this.model});
  }

  makeTopAlignmentRowView(): ProteinAlignmentRowView {
    return new ProteinAlignmentRowView({
      model: this.model,
      tabstate: this.model,
      row: this.model.get('alignment')!.rows[0],
      alignmentType: this.model.get('alignment')!.alignmentType,
      visibilityOptions: this.model.get('localVisibilityOptionsList')![0],
    });
  }

  registerListeners(): void {
    super.registerListeners();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'change:alignment', this.update);
  }

  getDefaultSpan(): number {
    if (
      BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_ENGINEERING_TOOLS &&
      this.model.get('visibilityOptions').getOption(vo.ANTIBODY_NUMBERING.name)!.get('visible')
    ) {
      return Math.floor(this.mapWidth() / (MIN_WIDTH_FOR_INDEX + 1));
    }

    return super.getDefaultSpan();
  }

  getDataTestAttrs(): DataTestAttrs {
    return {component: 'ProteinAlignmentTab', element: 'root'};
  }
}
